'use client'

import React from 'react'

export type CompanySectionKey =
  | 'users'
  | 'sessions'
  | 'regions'
  | 'departments'
  | 'quoteSources'
  | 'quotePurposes'
  | 'roles'
  | 'customers'
  | 'contacts'
  | 'contactPositions'
  | 'clientTypes'
  | 'entityRatings'
  | 'refusalReasons'
  | 'vendors'
  | 'drivers'
  | 'vehicles'
  | 'carriers'
  | 'clients'
  | 'shipments'
  | 'orders'
  | 'addresses'
  | 'cargos'
  | 'quotes'
  | 'currency'
  | 'activityLog'
  | 'auditLog'

function clsx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ')
}

export default function CompanySidebar({
  company,
  active,
  onChange,
}: {
  company: { id: string; name: string; domain?: string }
  active: CompanySectionKey
  onChange: (key: CompanySectionKey) => void
}) {
  const items: { key: CompanySectionKey; label: string }[] = [
    { key: 'clients', label: 'Clients' },
    { key: 'carriers', label: 'Carriers' },
    { key: 'drivers', label: 'Fleet — Drivers' },
    { key: 'vehicles', label: 'Fleet — Vehicles' },
    { key: 'users', label: 'Users' },
    { key: 'sessions', label: 'Sessions' },
    { key: 'quotes', label: 'Quotes' },
    { key: 'orders', label: 'Orders' },
    { key: 'cargos', label: 'Cargos' },
    { key: 'departments', label: 'Departments' },
    { key: 'addresses', label: 'Addresses' },
    { key: 'regions', label: 'Regions' },
    { key: 'quoteSources', label: 'Quote Sources' },
    { key: 'clientTypes', label: 'Client Types' },
    { key: 'entityRatings', label: 'Entity Ratings' },
    { key: 'refusalReasons', label: 'Refusal Reasons' },
    { key: 'contactPositions', label: 'Contact Positions' },
    { key: 'contacts', label: 'Contacts' },
    { key: 'roles', label: 'Roles (mock data)' },
    { key: 'activityLog', label: 'Activity log' },
    { key: 'auditLog', label: 'Audit log' },
  ]

  return (
    <div>
      <div className="mb-4">
        <h2 className="text-base font-semibold mb-1">Organization Settings</h2>
        <p className="text-xs text-subtext truncate" title={ company.domain || '' }>{ company.name }</p>
      </div>
      <div className="space-y-1">
        { items.map((item) => (
          <button
            key={ item.key }
            onClick={ () => onChange(item.key) }
            className={ clsx(
              'flex items-center w-full px-3 py-2 rounded-md text-sm hover:bg-accent transition-colors',
              active === item.key && 'bg-accent font-medium'
            ) }
          >
            { item.label }
          </button>
        )) }
      </div>
    </div>
  )
}
